module.exports = __webpack_public_path__ + "static/media/sent-query.25a04c4a.svg";